import { RangeInput as AntdRangeInput } from "@empglabs/backoffice-ui-kit"

const RangeInput = props => {
  return <AntdRangeInput {...props} />
}

export default RangeInput
